import { useState } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

import { Typography } from '@/components/typography/typography'
import { cn } from '@/libs/tw'

import { FormValues } from '../../schema'
import { FormTextInput } from './formTextInput'

type FormTypeAHeadProps = Parameters<typeof FormTextInput>[number] & {
	options?: string[]
	minLength?: number
}

export const FormTypeAHead = ({ options, minLength = 2, ...rest }: FormTypeAHeadProps) => {
	const [selectedValue, setSelectedValue] = useState<string>()
	const { setValue } = useFormContext<FormValues>()

	const value = useWatch({ name: rest.name })

	const results =
		value?.length >= minLength &&
		options?.filter((option) => option.toLowerCase().includes(value.toLowerCase()))

	const onSelect = (option: string) => {
		setSelectedValue(option)
		setValue(rest.name, option)
	}

	const show = value !== selectedValue && results && Boolean(results.length)

	return (
		<div className={cn('group relative')}>
			<FormTextInput {...rest} />
			{show && (
				<div
					className={cn(
						' absolute left-0 z-10 hidden max-h-[250px] flex-col overflow-auto rounded-8 border border-userData-textMobile bg-userData-bgSecondary group-focus-within:flex md:border-userData-text md:bg-userData-bg'
					)}
					tabIndex={1}
					role="listbox"
				>
					{results.map((option) => (
						<button
							key={option}
							type="button"
							role="option"
							onClick={() => onSelect(option)}
							onKeyDown={(e) => {
								if (e.key === 'Enter') onSelect(option)
							}}
							className={cn(
								'w-full px-16 py-8 text-left hover:border hover:border-userData-text'
							)}
						>
							<Typography element="span" style="p">
								{option}
							</Typography>
						</button>
					))}
				</div>
			)}
		</div>
	)
}
